export default function jumplist(element) {
    element?.addEventListener('change', (event) => {
        window.location.href = event.target.value;
    });
}
